export default __webpack_public_path__ + "static/media/portfolio-bg.3ef02ecd.jpg";